const routes = [
    {
        path: "/qr-verification/:filename",
        component: () => import("../pages/Index"),
        meta: {

        }
    }
];

export default routes;
